import { reactive, toRefs, watch } from 'vue';

import debounce from 'lodash/debounce';

const refine = R.compose(
    R.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'),
    R.replace(/( |\.)/gi, '')
);

export function useSearch({
    value = '',
    lazy = false,
    debounceTime = 200,
} = {}) {
    const state = reactive({
        value,
        lazyValue: value,
    });

    if (lazy) {
        watch(
            () => state.value,
            debounce((value) => {
                state.lazyValue = value;
            }, debounceTime)
        );
    }

    const setValue = (v) => (state.value = v);

    const filter = R.curryN(2, (extractor, list = []) => {
        const { value, lazyValue } = state;

        const _value = refine(lazy ? lazyValue : value);

        const _tester = R.compose(
            R.test(new RegExp(_value, 'gi')),
            refine,
            R.defaultTo(''),
            extractor
        );

        return list.filter(_tester);
    });

    let obj = {
        ...toRefs(state),
        setValue,
        filter,
    };

    return obj;
}
